/**
 * Development logger. Production stays quiet; development and tests still print.
 */
export function devLog(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args);
  }
}
